/**
 * Analytics service for tracking user engagement and SEO metrics
 * Can be integrated with Google Analytics, Matomo, or other analytics services
 */

// Initialize analytics (use actual implementation for preferred analytics platform)
const initAnalytics = () => {
  // Google Analytics is now initialized via the script in index.html
  // This function remains for compatibility and can be used for additional setup
  if (typeof window !== "undefined" && window.gtag) {
    console.log("Google Analytics is ready to track events");
  }
};

// Track page views
const trackPageView = (path, title) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", {
      page_title: title || document.title,
      page_path: path || window.location.pathname,
      send_to: "G-SYXS7E7ZS4",
    });
  }
};

// Track Core Web Vitals (important for SEO)
const trackWebVitals = (metric) => {
  if (typeof window !== "undefined" && window.gtag) {
    const name = metric.name || "metric";
    const id = metric.id || "";
    const value = Math.round(metric.value * 10) / 10;

    window.gtag("event", name, {
      metric_id: id,
      metric_value: value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      non_interaction: true,
      event_category: "Web Vitals",
      send_to: "G-SYXS7E7ZS4",
    });
  }
};

// Track user events
const trackEvent = (category, action, label, value) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
      send_to: "G-SYXS7E7ZS4",
    });
  }
};

// Track conversions (important for measuring SEO success)
const trackConversion = (conversionId, value = 0, currency = "USD") => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "conversion", {
      send_to: `G-SYXS7E7ZS4/${conversionId}`,
      value: value,
      currency: currency,
    });
  }
};

// Track search terms (important for SEO keyword research)
const trackSearch = (searchTerm) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "search", {
      search_term: searchTerm,
      send_to: "G-SYXS7E7ZS4",
    });
  }
};

// Track resource downloads (important for educational content analytics)
const trackResourceDownload = (resourceName, resourceType, resourceCategory) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "download", {
      event_category: "Resources",
      event_label: resourceName,
      resource_type: resourceType,
      resource_category: resourceCategory,
      send_to: "G-SYXS7E7ZS4",
    });
  }
};

export const analyticsService = {
  initAnalytics,
  trackPageView,
  trackWebVitals,
  trackEvent,
  trackConversion,
  trackSearch,
  trackResourceDownload,
};
